<template>
  <div class="sm-slider space-y-2">
    <div class="sm-slider__body">
      <input
        v-model.number="sliderValue"
        type="range"
        class="sm-slider__input"
        :style="trackStyle" />
      <div class="sm-slider__value">
        {{ sliderValue }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  const value = defineModel<number | null>({
    default: null,
  })

  const sliderValue = computed({
    get: function () {
      return value.value ?? 0
    },
    set: function (newValue: number) {
      value.value = newValue
    },
  })

  const trackStyle = computed(function () {
    return {
      '--sm-slider-percentage': `${percentage()}%`,
    }
  })

  function percentage() {
    return Math.round(sliderValue.value)
  }
</script>

<style lang="scss">
  .sm-slider {
    display: flex;
    flex-direction: column;

    &__legend {
      display: flex;
      justify-content: space-between;
      font-size: 0.875rem;
      color: var(--el-text-color-secondary);
    }

    &__label {
      min-width: 3ch;
    }

    &__body {
      display: flex;
      align-items: center;
      gap: 0.75rem;
    }

    &__input {
      --sm-slider-percentage: 0%;
      appearance: none;
      width: 100%;
      height: 8px;
      border-radius: 999px;
      background: linear-gradient(
        90deg,
        var(--sm-primary) 0%,
        var(--sm-primary) var(--sm-slider-percentage),
        theme('colors.gray[300]') var(--sm-slider-percentage),
        theme('colors.gray[300]') 100%
      );
      outline: none;
      transition: background 0.2s ease;
    }

    &__input::-webkit-slider-thumb,
    &__input::-moz-range-thumb,
    &__input::-ms-thumb {
      appearance: none;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: var(--sm-primary);
      border: 1px solid var(--sm-primary);
      cursor: pointer;
    }

    &__value {
      min-width: 3ch;
      text-align: right;
      font-weight: 600;
    }
  }

  .dark .sm-slider__input {
    background: linear-gradient(
      90deg,
      var(--sm-primary) 0%,
      var(--sm-primary) var(--sm-slider-percentage),
      theme('colors.gray[400]') var(--sm-slider-percentage),
      theme('colors.gray[400]') 100%
    );
  }
</style>
